import type {
    DeleteNewsCategoryResponseType,
    DeleteNewsCategoryRequestType
} from "./type";
import {
    request
} from "../request";

const DeleteNewsCategory = async (params: DeleteNewsCategoryRequestType): Promise<DeleteNewsCategoryResponseType> => {
    return await request<DeleteNewsCategoryResponseType>("/news/deleteNewsCategory", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default DeleteNewsCategory;
